import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentsUIHelpers";

const StudentsUIContext = createContext();

export function useStudentsUIContext() {
  return useContext(StudentsUIContext);
}

export const StudentsUIConsumer = StudentsUIContext.Consumer;

export function StudentsUIProvider({ studentsUIParameters, children }) {
  const [sectionValues, setSectionValues] = useState();
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    sectionValues,
    setSectionValues,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    currentTerm: studentsUIParameters.currentTerm,
    currentSectionId: studentsUIParameters.currentSectionId,
    newTerm: studentsUIParameters.newTerm,
    newSectionId: studentsUIParameters.newSectionId
  };

  return (
    <StudentsUIContext.Provider value={value}>
      {children}
    </StudentsUIContext.Provider>
  );
}